import { useCourseKit } from "@bodemleven/course-kit/react";
import { commonCopy, type CommonCopy } from "./common.ts";

/** The common strings in the visitor's current locale (nl or en). */
export const useCommonCopy = (): CommonCopy => commonCopy[useCourseKit().locale];
